import { Injectable } from '@angular/core';
import { UtilityService } from './utility.service';
import {  AngularFireDatabase,AngularFireObject, AngularFireList } from 'angularfire2/database';
import { Constants } from '../config/Constants';
import { Observable } from 'rxjs/Observable';
import { Session } from '../models/session'
import { Questions } from '../models/question-answer';


@Injectable()
export class QuestionAnswerService {

  constructor(private db: AngularFireDatabase,private utilityService:UtilityService) { }

  getAllQuestionAnswer(eventId: string):Observable<Questions> {
    if(eventId != null) {
      let data :AngularFireObject<Questions> = this.db.object(Constants.EVENT_USER_DATA_URL+'/'+eventId+Constants.QUESTIONS_URL);
      return  data.valueChanges();
    }
  }
  
  getEvenQuestionAnswer(eventId: string):Observable<Questions> {
    if(eventId != null) {
      let data :AngularFireObject<Questions> = this.db.object(Constants.EVENT_USER_DATA_URL+'/'+eventId+Constants.QUESTIONS_URL);
      return  data.valueChanges();
    }
  }

  getSessionQuestionAnswer(eventId):Observable<Questions> {
    if(eventId != null) {
      let data :AngularFireObject<Questions> = this.db.object(Constants.EVENT_USER_DATA_URL+'/'+eventId+Constants.QUESTIONS_URL);
      return  data.valueChanges();
    }
  }

}



// WEBPACK FOOTER //
// /app/src/app/core/services/question-answer.service.ts